module.exports = __webpack_public_path__ + "static/media/mileage_2_7.c53b989e.png";